/**
 * REPUTE Collection — View Toggle, Filter Drawer, Quick Add
 */
(function () {
  'use strict';

  /* ---- View Toggle (3 vs 4 columns) ---- */
  const grid = document.getElementById('rpt-product-grid');
  const viewBtns = document.querySelectorAll('.rpt-collection__view-btn');

  viewBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      const cols = btn.dataset.columns;
      if (!grid || !cols) return;

      // Update grid class
      grid.classList.remove('rpt-collection__grid--1-col', 'rpt-collection__grid--2-col', 'rpt-collection__grid--3-col', 'rpt-collection__grid--4-col');
      grid.classList.add('rpt-collection__grid--' + cols + '-col');

      // Update active state — only toggle within same group (mobile/desktop)
      var isMobile = btn.classList.contains('rpt-collection__view-btn--mobile');
      var groupClass = isMobile ? 'rpt-collection__view-btn--mobile' : 'rpt-collection__view-btn--desktop';
      viewBtns.forEach(function (b) {
        if (b.classList.contains(groupClass)) {
          b.classList.remove('rpt-collection__view-btn--active');
          b.setAttribute('aria-pressed', 'false');
        }
      });
      btn.classList.add('rpt-collection__view-btn--active');
      btn.setAttribute('aria-pressed', 'true');

      // Persist preference — separate for mobile/desktop
      try {
        var storageKey = isMobile ? 'rpt-grid-columns-mobile' : 'rpt-grid-columns';
        sessionStorage.setItem(storageKey, cols);
      } catch (e) { /* noop */ }
    });
  });

  // Restore persisted preference — only for the relevant group (mobile/desktop)
  try {
    var isMobileView = window.innerWidth < 768;
    var savedKey = isMobileView ? 'rpt-grid-columns-mobile' : 'rpt-grid-columns';
    var saved = sessionStorage.getItem(savedKey);
    if (saved && grid) {
      grid.classList.remove('rpt-collection__grid--1-col', 'rpt-collection__grid--2-col', 'rpt-collection__grid--3-col', 'rpt-collection__grid--4-col');
      grid.classList.add('rpt-collection__grid--' + saved + '-col');
      var groupClass = isMobileView ? 'rpt-collection__view-btn--mobile' : 'rpt-collection__view-btn--desktop';
      viewBtns.forEach(function (b) {
        if (b.classList.contains(groupClass)) {
          var isActive = b.dataset.columns === saved;
          b.classList.toggle('rpt-collection__view-btn--active', isActive);
          b.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        }
      });
    }
  } catch (e) { /* noop */ }

  /* ---- Filter Drawer ---- */
  var filterDrawer = document.getElementById('rpt-filter-drawer');
  var filterToggle = document.querySelector('[data-filter-toggle]');
  var filterCloseEls = document.querySelectorAll('[data-filter-close]');
  var filterApply = document.querySelector('[data-filter-apply]');

  function openFilter() {
    if (!filterDrawer) return;
    filterDrawer.setAttribute('aria-hidden', 'false');
    if (filterToggle) filterToggle.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';

    // Focus first interactive element
    requestAnimationFrame(function () {
      var first = filterDrawer.querySelector('input, button, a, [tabindex]');
      if (first) first.focus();
    });
  }

  function closeFilter() {
    if (!filterDrawer) return;
    filterDrawer.setAttribute('aria-hidden', 'true');
    if (filterToggle) {
      filterToggle.setAttribute('aria-expanded', 'false');
      filterToggle.focus();
    }
    document.body.style.overflow = '';
  }

  if (filterToggle) {
    filterToggle.addEventListener('click', openFilter);
  }

  filterCloseEls.forEach(function (el) {
    el.addEventListener('click', closeFilter);
  });

  // Close on Escape
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && filterDrawer && filterDrawer.getAttribute('aria-hidden') === 'false') {
      closeFilter();
    }
  });

  // Apply filters — build URL from checked values and navigate
  if (filterApply) {
    filterApply.addEventListener('click', function () {
      if (!filterDrawer) return;

      var params = [];
      var checkboxes = filterDrawer.querySelectorAll('input[type="checkbox"]:checked');
      checkboxes.forEach(function (cb) {
        params.push(encodeURIComponent(cb.name) + '=' + encodeURIComponent(cb.value));
      });

      // Price range
      var priceFields = filterDrawer.querySelectorAll('.rpt-filter-drawer__price-field');
      priceFields.forEach(function (field) {
        if (field.value) {
          params.push(encodeURIComponent(field.name) + '=' + encodeURIComponent(field.value));
        }
      });

      var base = window.location.pathname;
      var url = params.length > 0 ? base + '?' + params.join('&') : base;
      window.location.href = url;
    });
  }

  /* ---- Model Toggle ---- */
  var modelToggle = document.getElementById('rpt-model-toggle');
  if (modelToggle) {
    modelToggle.addEventListener('click', function () {
      var isActive = modelToggle.getAttribute('aria-pressed') === 'true';
      var newState = !isActive;
      modelToggle.setAttribute('aria-pressed', newState ? 'true' : 'false');

      document.querySelectorAll('.rpt-product-card').forEach(function (card) {
        var primary = card.querySelector('.rpt-product-card__image--primary');
        var secondary = card.querySelector('.rpt-product-card__image--secondary');
        if (!primary || !secondary) return;

        if (newState) {
          /* Model ON: show secondary (model image), hide primary */
          primary.style.opacity = '0';
          secondary.style.opacity = '1';
        } else {
          /* Model OFF: show primary (product image), hide secondary */
          primary.style.opacity = '';
          secondary.style.opacity = '';
        }
      });
    });
  }

  /* ---- Quick Add ---- */
  document.querySelectorAll('.rpt-product-card__quick-add').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();

      var variantId = btn.dataset.variantId;
      if (!variantId) return;

      btn.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
      })
        .then(function (res) {
          if (!res.ok) throw new Error('Add to cart failed');
          return res.json();
        })
        .then(function () {
          // Dispatch custom event for cart drawer
          document.dispatchEvent(new CustomEvent('repute:cart:updated'));

          // Visual feedback
          btn.innerHTML = '<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2 7L5.5 10.5L12 3.5" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
          setTimeout(function () {
            btn.innerHTML = '<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7 0.5V13.5M0.5 7H13.5" stroke="currentColor" stroke-width="1.2" stroke-linecap="round"/></svg>';
            btn.disabled = false;
          }, 1500);
        })
        .catch(function () {
          btn.disabled = false;
          // Fallback: navigate to product page
          var url = btn.dataset.productUrl;
          if (url) window.location.href = url;
        });
    });
  });
})();
